import { AvcoreSubcribeStreamApiCredentials } from "@common/domain";
import { StreamData } from "../../actions";
import { SubscribeConferenceApi } from "../conferenceApi";
import { BaseConferenceStream } from "./BaseConferenceStream";

export class RemoteConferenceStream extends BaseConferenceStream {
  private readonly _subscribeConferenceApi: SubscribeConferenceApi;

  constructor(
    readonly streamData: StreamData,
    readonly streamApiCredentials: AvcoreSubcribeStreamApiCredentials,
    logger: (...args: unknown[]) => void
  ) {
    super(streamData.streamId);

    this._subscribeConferenceApi = new SubscribeConferenceApi(
      this.streamData,
      this.streamApiCredentials,
      logger
    );
  }

  get lastScore$() {
    return this._subscribeConferenceApi.lastScore$;
  }

  get stats$() {
    return this._subscribeConferenceApi.stats$;
  }

  async subscribeStream() {
    const stream = await this._subscribeConferenceApi.subscribe();

    this._stream$.next(stream);

    return this;
  }

  override async destroy() {
    try {
      await this._subscribeConferenceApi.destroy();
    } finally {
      super.destroy();
    }
  }
}
